export const ADD_MUSICIAN_JOBS = 'ADD_MUSICIAN_JOBS';

// This are the 4 main items.